import { render, staticRenderFns } from "./SaleReturnDetail.vue?vue&type=template&id=5bbccf9f"
import script from "./SaleReturnDetail.vue?vue&type=script&lang=js"
export * from "./SaleReturnDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports